// cart.js

const Cart = {
    /**
     * Fetches the current cart object
     * @returns {Promise} Resolves with the cart JSON object
     */
    getCart: function() {
        return fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(cart => {
            return cart;
        })
        .catch(error => {
            console.error("Error fetching cart:", error);
        });
    },

    /**
     * Updates the cart with a new quantity for a given variant ID
     * @param {Number} variantId - The Shopify Variant ID
     * @param {Number} quantityChange - The amount to add (positive) or remove (negative)
     */
    updateCartQuantity: function(variantId, quantityChange, element) {
        const container = element.closest(".action.purchase");

        this.getCart().then(cart => {
            let cartItem = cart.items.find(item => item.variant_id == variantId);
            let currentQuantity = cartItem ? cartItem.quantity : 0;
            let newQuantity = currentQuantity + quantityChange;
    
            if (newQuantity < 0) newQuantity = 0;
            if (newQuantity === currentQuantity) return;
    
            let fetchUrl = cartItem ? '/cart/change.js' : '/cart/add.js';
            let requestBody = cartItem
                ? { id: cartItem.key, quantity: newQuantity } 
                : { id: variantId, quantity: quantityChange };
    
            return fetch(fetchUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            })
            .then(response => response.json())
            .then(() => Cart.refreshCart())
            .then(updatedCart => {
                if (!updatedCart || !updatedCart.items) {
                    console.error("Error: Updated cart is empty", updatedCart);
                    return;
                }
                Cart.updateUI(updatedCart);
    
                if(container) container.classList.remove("thinking-plus", "thinking-minus"); // Remove class after update
                element.classList.remove("active");
            })
            .catch(error => {
                console.error("Error updating cart:", error);
            });
        }).catch(error => console.error("Failed to update cart:", error));
    },

    updateUI: function(cart) {

        if(cart.items.length === 0){
          document.querySelectorAll(".action.purchase p").forEach(p => {
                p.innerHTML = "0";
          });
          document.querySelectorAll(".minus").forEach(p => {
            p.classList.remove("visible");
          });
          
        }else{

          // Update Dessert Track
          hasDessert = cart.items.some(item => item.variant_title === "Dessert");

          let allPurchaseElements = document.querySelectorAll(".action.purchase");
          let cartVariantMap = new Map(cart.items.map(item => [item.variant_id, item]));

          allPurchaseElements.forEach(action => {           
              let variantId = parseInt(action.getAttribute("data-variant-id"));
              let quantityElement = action.querySelector("p");
              let minusButton = action.querySelector(".minus");
          
              if (cartVariantMap.has(variantId)) {
                  // If variant is in the cart, update quantity
                  let cartItem = cartVariantMap.get(variantId);
                  if (quantityElement) quantityElement.innerHTML = cartItem.quantity;
                  if (minusButton && cartItem.quantity > 0) minusButton.classList.add("visible");
              } else {
                  // If variant is NOT in the cart, set quantity to 0 and hide minus button
                  if (quantityElement) quantityElement.innerHTML = "0";
                  if (minusButton) minusButton.classList.remove("visible");
              }
          });
          
        }
        
        // Update Basket
        let totalQuantity = cart.items.reduce((total, item) => total + item.quantity, 0);
        let basketVolumeElement = document.querySelector(".header .basket .volume");
        if (basketVolumeElement) {
          basketVolumeElement.innerHTML = totalQuantity + " Meals";
        }      

        let totalValue = cart.items.reduce((total, item) => total + (item.quantity * item.price), 0) / 100;

        //Discount Upgrade
        //totalValue = (cart.items.reduce((total, item) => total + (item.quantity * item.price), 0) * 0.7) / 100;

        let formattedTotalValue = new Intl.NumberFormat('en-US', { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
        }).format(totalValue);      
        formattedTotalValue = `$${formattedTotalValue}`;
        let basketValueElement = document.querySelector(".header .basket .value");
        if (basketValueElement) {
          basketValueElement.innerHTML = formattedTotalValue;
        } 

      let cartTotal = document.querySelector("#cart_total");
      let cartSubTotal = document.querySelector("#cart_subtotal");
      let cartMeals = document.querySelector("#cart_meals");
      if(cartTotal){
        cartTotal.innerHTML = formattedTotalValue;

        const checkoutButton = document.querySelector('#payment-checkout-action');
        if(checkoutButton){
          if (checkoutButton.textContent == 'Minimum order of $30 applies') {
            checkoutButton.textContent = 'Proceed to Payment';
            checkoutButton.classList.remove('warning');
          }
        }
        
      }
      if(cartSubTotal){
        cartSubTotal.innerHTML = formattedTotalValue;
      }
      if(cartMeals){
        cartMeals.innerHTML = totalQuantity;
      }

        
    },

    /**
     * Refreshes the cart object (Refetch latest cart state)
     * @returns {Promise} Resolves with the updated cart JSON object
     */
    refreshCart: function() {
        return this.getCart().then(updatedCart => {
            return updatedCart;
        });
    }
};

function initialiseCartButtons(parent) 
{
    document.querySelectorAll(parent + " .action.purchase .minus," + parent + " .action.purchase .plus").forEach(button => {
        button.addEventListener("click", function(event) {
            let actionContainer = this.closest(".action.purchase"); // Find the closest .action parent
            if (!actionContainer) return;
    
            let quantityElement = actionContainer.querySelector("p"); // Get the quantity display
            if (!quantityElement) return;
    
            let currentQuantity = parseInt(quantityElement.innerHTML) || 0; // Get current quantity
    
            // Prevent minus click if quantity is already 0
            if (this.classList.contains("minus") && currentQuantity === 0) {
                return; // Do nothing if trying to decrease from 0
            }
    
            this.classList.add("active"); // Add active class during processing
    
            let variantId = actionContainer.getAttribute("data-variant-id");
            if (!variantId) return;
    
            if (this.classList.contains("minus")) {
                Cart.updateCartQuantity(variantId, -1, this);
            } else if (this.classList.contains("plus")) {
                Cart.updateCartQuantity(variantId, 1, this);
            }
        });
    });
}

function initialiseQuantityDropdowns(parent) {
  document.querySelectorAll(parent + " .quantity-dropdown").forEach(dropdown => {
    const display = dropdown.querySelector(".value");
    const options = dropdown.querySelectorAll(".options li");

    // Toggle dropdown open/close when clicking the <p>
    display.addEventListener("click", (e) => {
      e.stopPropagation(); // prevent clicks bubbling up
      const container = dropdown.closest(".action.purchase");
      if (container.classList.contains("thinking-plus") || container.classList.contains("thinking-minus")) return;
      dropdown.classList.toggle("open");
    });

    // Handle option selection
    options.forEach(option => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        const newQty = parseInt(option.dataset.value, 10);
        const variantId = dropdown.closest(".action.purchase").dataset.variantId;

        if (!variantId) return;

        const currentQty = parseInt(display.textContent, 10) || 0;

        // Update display
        display.textContent = newQty;

        // Close dropdown
        dropdown.classList.remove("open");

        if(newQty > currentQty){
          dropdown.closest(".action.purchase").classList.add("thinking-plus"); // add thinking
        }else {
          dropdown.closest(".action.purchase").classList.add("thinking-minus"); // add thinking
        }
        

        // Trigger cart update
        Cart.updateCartQuantity(variantId, newQty - currentQty, dropdown);
      });
    });

    // Close dropdown if clicking outside
    document.addEventListener("click", () => {
      dropdown.classList.remove("open");
    });
  });
}

  document.addEventListener("DOMContentLoaded", function() {
    initialiseCartButtons("body");
    initialiseQuantityDropdowns("body");
  });

// Set initial Cart Items
Cart.getCart().then(cart => Cart.updateUI(cart));
